module.exports = __webpack_public_path__ + "static/media/groupMessageIcon.a59917ad.svg";